import script from "./StatsPageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatsPageView.vue?vue&type=script&setup=true&lang=ts"

import "./StatsPageView.vue?vue&type=style&index=0&id=cbabdff0&lang=css"

const __exports__ = script;

export default __exports__